import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import InputCopy from '../../components/InputCopy';
import Button from '../../components/Button';
import Container from '../../components/Container';
import Typography from '../../components/Typography';
import ProgressStep from '../../components/ProgressStep';
import StepInterface from '../../interfaces/Step';
import StepClass from '../../entities/Step';
import ProgressBar from '../../components/ProgressBar';
import { gtmAttributesUpdateIntegrationTokenPage } from '../../utils/gtmVariables';
import useGTMEventsTracker from '../../hooks/useGTMEventsTracker';

interface LocationState {
  to: string;
  token: string;
}

const Step = new StepClass();

const Integration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { to = '', token = '' } = (location?.state as LocationState) || {};
  const current: number = 4;
  const steps: Array<StepInterface> = Step.steps();
  const gtmEventsTracker = useGTMEventsTracker();

  gtmEventsTracker(gtmAttributesUpdateIntegrationTokenPage);

  return (
    <>
      <Container className="block max-[913px]:hidden">
        <ProgressStep steps={steps} current={current} />
      </Container>
      <Container className="block px-5 py-6 min-[914px]:hidden">
        <ProgressBar
          total={steps.length}
          step={current}
          subtitle={steps.find((e) => e.step === current)?.title ?? ''}
        />
      </Container>
      <Container className="m-auto grid justify-center items-center pt-14 pb-20 max-w-2xl">
        <Typography as="h1" variant="subtitle2" className="text-center pb-12">
          A integradora da sua loja já está habilitada
        </Typography>
        <InputCopy buttonText="Copiar token" inputValue={token} id="mp__integration_input-copy" />
        <Typography as="p" variant="body2" className="text-justify pt-6 break-words">
          Copie este código e cole no campo indicado no painel de sua integradora para ativar a
          integração e volte para finalizar seu cadastro.
        </Typography>
        <Button
          text="Continuar"
          type="submit"
          variant="primary"
          classNames="my-6"
          onClick={() => navigate(to)}
        />
      </Container>
    </>
  );
};

export default Integration;
